import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueGlobalCount } from '../../../store/emarsys/action';
import { PAGE_NAME_TEST_DRIVE } from '../../../constants/emarsys/test-drive';

const useImpressionTestDriveList = (
  firstRef: React.RefObject<HTMLElement>,
  title: string,
  sectionName: string = '',
  optionalData?: {
    category?: string;
    car_model?: string;
    menu_cat_lvl2?: string;
  }
) => {
  const dispatch = useDispatch();
  const { screenSize } = useSelector((state: IRootState) => state.page) || {
    screenSize: 0,
  };
  const isLargeScreen = screenSize?.width >= 1240;
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      if (isAuth && isFlagActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: PAGE_NAME_TEST_DRIVE.TEST_DRIVE_LISTING_PAGE,
          page_url: window.location.href,
          page_title: title,
          car_category: optionalData?.category?.toLowerCase(),
          menu_cat_lvl1: 'test drive',
          section_name: sectionName,
          car_model: optionalData?.car_model,
          menu_cat_lvl2: optionalData?.menu_cat_lvl2?.toLowerCase(),
        };

        for (const key in valuePageView) {
          if (valuePageView[key] === undefined) {
            delete valuePageView[key];
          }
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueGlobalCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionTestDriveList;
